import {IAgencyCostActivityImperial, IAgencyCostImperial} from "@/modules/agencyCost/interfaces/agencyCost";
import {getLineItemCost, getLineItemNpv, getQuantityImperial} from "@/modules/agencyCost/lib/calculations/lineItem";

export const prepareScenarioForAnalysis = function(scenario: IAgencyCostImperial){
  // console.log(scenario.name);
  scenario.activities.forEach(A => {
    A.lineItems.forEach(L => {
      L.quantity = getQuantityImperial(L, scenario);
      // console.log(L.name, L.quantity)
    })
  })

};

export const getTotalActivityCost = function(activity: IAgencyCostActivityImperial){

  const lineItemCosts = activity.lineItems.map(L => getLineItemCost(L));

  return lineItemCosts.reduce((a, b) => a + b, 0)

};


export const getTotalActivityNpv = function(activity: IAgencyCostActivityImperial, discountRate: number){

  const lineItemCosts = activity.lineItems.map(L => getLineItemNpv(L, discountRate, activity.yearsAfterStart));

  return lineItemCosts.reduce((a, b) => a + b, 0)

};
